import { render, staticRenderFns } from "./PlusMenu.vue?vue&type=template&id=130ceca6"
import script from "./PlusMenu.vue?vue&type=script&lang=js"
export * from "./PlusMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports